import classNames from 'classnames';
import { ReactNode } from 'react';
import { Accordion } from '~/components/Accordion/v2/Accordion';
import { T } from '~/components/I18n';
import { Chevron } from '~/components/Icon/v2/Chevron';
import accordionStyles from '~/components/Status/Bar/StatusBarAccordion.module.scss';

export type StatusBarAccordionProps = {
  className?: string;
  children?: ReactNode;
};

export const StatusBarAccordion = ({ className, children }: StatusBarAccordionProps) => (
  <Accordion.Root className={classNames(accordionStyles.root, className)}>
    {({ active }) => (
      <>
        <Accordion.Body
          className={classNames(accordionStyles.body, {
            [accordionStyles.activeBody]: active,
          })}>
          {children}
        </Accordion.Body>
        <Accordion.Button
          className={accordionStyles.button}
          variant="transparent"
          icon={<Chevron direction={active ? 'top' : 'bottom'} className={accordionStyles.icon} />}>
          {active ? (
            <T name="citizen_land_menu_myhistory_fold" />
          ) : (
            <T name="citizen_land_menu_myhistory_unfold" />
          )}
        </Accordion.Button>
      </>
    )}
  </Accordion.Root>
);
